import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import TableWrapper from "../Table/tableWrapper";
import {getThirdPartyListTable} from "../../Util/TableHelpers/thirdPartyUsageTable";
import {createThirdPartyUsageCSVContent} from "../../Util/TableHelpers/thirdPartyUsageCSVDownloadHelper";
import {getThirdPartyDetails, getThirdPartyList} from "../../Actions/thirdPartyAction";
import LoadingSpinner from "../CommonComponents/loadingSpinner";

const ThirdPartyTableHeaders = ["Date", "Billing Amount($)", "Outstanding Balance($)", "Details"];

const ThirdPartyTableSection = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const thirdPartyList = useSelector(state => state.thirdPartyList);

    useEffect(() => {
        const fetchThirdPartyData = async () => {
            setIsLoading(true);
            await dispatch(getThirdPartyList());
            setIsLoading(false);
        }

        fetchThirdPartyData();
    }, [dispatch]);

    const tableOption = {
        firstChildHighlight: true
    }

    const resolveThirdPartyDetailsPayload = (details) => {
        if (!details) return null;
        if (typeof details.getThirdPartyDetails === "function") {
            return details.getThirdPartyDetails();
        }
        return details.thirdPartyDetails ?? details;
    };

    const triggerCsvDownload = (date, csvContent) => {
        if (!csvContent) return;
        const filename = `thirdParty_details_${date ?? "details"}.csv`;
        let url;
        let link;
        try {
            const blob = new Blob([csvContent], {type: "text/csv"});
            url = window.URL.createObjectURL(blob);
            link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
        } finally {
            if (link) document.body.removeChild(link);
            if (url) window.URL.revokeObjectURL(url);
        }
    };

    const handleDownload = async (billingDate) => {
        if (!billingDate) return;
        setIsLoading(true);
        try {
            const thirdPartyDetailsObj = await dispatch(getThirdPartyDetails(billingDate));
            const payload = resolveThirdPartyDetailsPayload(thirdPartyDetailsObj);
            if (!payload) return;
            const csvContent = createThirdPartyUsageCSVContent(billingDate, payload);
            triggerCsvDownload(billingDate, csvContent);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // const partnerDetails = useSelector(state => state.partnerDetails);
    // const partnerAccountsObj = useSelector(state => state.partnerAccounts);
    // const thirdPartyBillingDetails = useSelector(state => state.thirdPartyBillingDetails);

    const tableBodyArr = thirdPartyList
        ? getThirdPartyListTable(thirdPartyList.thirdPartyList, handleDownload)
        : [];

    const containerClassName = "row p-2 ps-0 min-width-md-parent position-relative";

    return (
        <div className={containerClassName}>
            <TableWrapper
                tableHeaderArr={ThirdPartyTableHeaders}
                tableBodyArr={tableBodyArr}
                option={tableOption}
                errorText={thirdPartyList == null ? "You do not have any account with third party usage" : undefined}
            />
            {isLoading && (
                <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{backgroundColor: "rgba(255,255,255,0.6)", zIndex: 10}}
                >
                    <LoadingSpinner/>
                </div>
            )}
        </div>
    )
}

export default ThirdPartyTableSection;
